import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from '@src/pc/components/Header';
import StationList from '@src/pc/index/layout/StationList';
import SupportList from '@src/pc/index/layout/SupportList';
import GoTop from '@src/pc/components/goTop';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import { chipMap } from '../chipMap';

const Layout = ({ content }) => {
    return (
        <div className={styles.layout}>
            <Chip key="mainImage" {...chipMap.mainImage}>
                <Header img={content.mainImage?.pc_other} />
            </Chip>
            <div className={styles.content}>
                <img src={require('../../assets/entries.png')} alt="" useMap="#entriesMap" />
                <map name="entriesMap" id="entriesMap">
                    {/* eslint-disable-next-line no-undef */}
                    <area shape="rect" coords="40.5546875,40.40234375,545.75390625,194.8671875" href={`${linkUrl}/rule`} target="_blank" alt="0" />
                    {/* eslint-disable-next-line no-undef */}
                    <area shape="rect" coords="606.77734375,40.91015625,958.890625,195.2734375" href={`${linkUrl}/brand`} target="_blank" alt="1" />
                </map>

                <div className={styles.ad}>
                    <Chip key="adLink" {...chipMap.adLink}>
                        <a href={content.adLink.url} target="_blank">
                            <img src={content.adLink.image} alt="" />
                        </a>
                    </Chip>
                </div>

                <div>
                    <img className={styles.title} src={require('../../assets/title_1.png')} alt="" />
                    <Chip key="stationList" {...chipMap.stationList} content={content.stationList}>
                        <StationList />
                    </Chip>
                </div>

                <div>
                    <img className={styles.title} src={require('../../assets/title_2.png')} alt="" style={{ marginBottom: '40px' }} />
                    <img className={styles.leaderSupport} src={require('../../assets/leader_support.png')} alt="首席赞助" />
                    <img className={styles.beer} src={require('../../assets/support_beer.png')} alt="匠心营造啤酒" />
                </div>
            </div>
            <Chip key="supportList" {...chipMap.supportList} content={content.supportList}>
                <SupportList />
            </Chip>
            <GoTop />
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
